import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtDate } from "@/lib/api";

export const ReplaceScenarioDialog = ({ pending, saved, onReplace, onCancel, busy }) => (
  <Dialog open={!!pending} onOpenChange={(o) => !o && onCancel()}>
    <DialogContent data-testid="replace-scenario-dialog" className="bg-[#121212] border-[#2A2A2A] text-white">
      <DialogHeader>
        <DialogTitle className="font-display">All 3 scenario slots are full</DialogTitle>
        <DialogDescription className="text-[#A3A3A3]">
          Pick a saved scenario to replace with "{pending?.label}", or cancel to keep things as they are.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-2">
        {saved.map((s) => (
          <button key={s.id} data-testid={`replace-scenario-${s.id}`} disabled={busy} onClick={() => onReplace(s.id)}
            className="w-full flex items-center justify-between gap-3 rounded-lg border border-[#2A2A2A] px-4 py-3 text-left hover:border-[#FFB800] hover:bg-[#FFB800]/[0.06] transition-colors disabled:opacity-40">
            <span className="min-w-0">
              <span className="block text-sm truncate">{s.label}</span>
              <span className="block text-[11px] text-[#A3A3A3]">{s.zero_cash_date ? fmtDate(s.zero_cash_date) : "Not in 24 mo"}</span>
            </span>
            <span className="font-mono text-[11px] text-[#FFB800] shrink-0">Replace</span>
          </button>
        ))}
      </div>
      <button data-testid="replace-scenario-cancel" onClick={onCancel}
        className="mt-2 w-full rounded-full border border-[#2A2A2A] py-2.5 text-sm hover:border-white transition-colors">Cancel, don't save</button>
    </DialogContent>
  </Dialog>
);
